module.exports = __webpack_public_path__ + "static/media/blueCheck.97c8f9ca.svg";